import { StepComponent } from "../../../../shared/components/ModalFlow/types";
import { FlowUploadDocumentProps } from "./types";
import {
  WSActions,
  WSCard,
  WSElement,
  WSList,
  WSSectionToolbar,
  WSText
} from "@wingspanhq/fe-component-library";

export const Step1: StepComponent<FlowUploadDocumentProps> = ({
  state,
  setState,
  onNext,
  onBack,
  children
}) => {
  return (
    <WSList gap="2XL">
      <WSElement>
        <WSSectionToolbar title="Insurance document upload instructions" />
        <WSText.ParagraphSm color="gray500">
          Before you begin, review these steps to ensure your insurance document
          will be uploaded and accurately processed:
        </WSText.ParagraphSm>
      </WSElement>

      <WSCard>
        <WSText.ParagraphSm px="L" py="S">
          <WSElement as="ol">
            <WSElement as="li" mb="L">
              <WSText.ParagraphSm weight="medium" mb="XS">
                Prepare your document
              </WSText.ParagraphSm>
              <WSElement as="ul" ml="M">
                <WSElement as="li">
                  <WSText.ParagraphSm>
                    Make sure you have a current, valid document — it must not
                    be expired.
                  </WSText.ParagraphSm>
                </WSElement>
                <WSElement as="li">
                  <WSText.ParagraphSm>
                    Ensure the document is complete and easy to read, with all
                    necessary fields clearly visible.
                  </WSText.ParagraphSm>
                </WSElement>
                <WSElement as="li">
                  <WSText.ParagraphSm>
                    Avoid blurry or poorly cropped files, as we extract
                    important information directly from the upload.
                  </WSText.ParagraphSm>
                </WSElement>
              </WSElement>
            </WSElement>

            <WSElement as="li" mb="L">
              <WSText.ParagraphSm weight="medium" mb="XS">
                Acceptable file formats
              </WSText.ParagraphSm>
              <WSText.ParagraphSm mb="XS">
                Uploads must be in one of the following formats:
              </WSText.ParagraphSm>
              <WSElement as="ul" ml="M">
                <WSElement as="li">
                  <WSText.ParagraphSm>
                    Images (jpeg, png, webp, heic, heif)
                  </WSText.ParagraphSm>
                </WSElement>
                <WSElement as="li">
                  <WSText.ParagraphSm>Max 100MBs per file</WSText.ParagraphSm>
                </WSElement>
              </WSElement>
            </WSElement>

            <WSElement as="li" mb="L">
              <WSText.ParagraphSm weight="medium" mb="XS">
                Upload and review your file
              </WSText.ParagraphSm>
              <WSElement as="ul">
                <WSElement as="li">
                  <WSText.ParagraphSm>
                    Once uploaded, we'll automatically extract key information
                    from the file (e.g., coverage type, expiration date).
                  </WSText.ParagraphSm>
                </WSElement>
                <WSElement as="li">
                  <WSText.ParagraphSm>
                    Carefully review all information for accuracy. If anything
                    looks off or incomplete, you can re-upload a corrected
                    version immediately.
                  </WSText.ParagraphSm>
                </WSElement>
              </WSElement>
            </WSElement>

            <WSElement as="li">
              <WSText.ParagraphSm weight="medium" mb="XS">
                Import policies from file
              </WSText.ParagraphSm>
              <WSText.ParagraphSm>
                Once imported, the policies extracted from your file will be
                securely stored in your "Settings {">"} My resources" section.
              </WSText.ParagraphSm>
              <WSText.ParagraphSm>
                You can return there anytime to view your policies or upload new
                documents.
              </WSText.ParagraphSm>
            </WSElement>
          </WSElement>
        </WSText.ParagraphSm>
      </WSCard>

      <WSActions
        alignment="fill"
        buttons={[
          {
            label: "Cancel",
            onClick: onBack,
            kind: "Secondary"
          },
          {
            label: "Continue",
            onClick: onNext
          }
        ]}
      />
    </WSList>
  );
};
